import { createFileRoute } from '@tanstack/react-router'
import { ProjectsPage } from '@/features/dashboard/ProjectsPage'

/**
 * The full-page Projects view — the destination of the dashboard's projects
 * "View All". The page composition (workspace-scoped `ProjectsTable` + the F3
 * DISCOVERABLE region + the account_v2 create dialog) lives in the feature
 * module; this route just mounts it. Rendered with `hideWorkspace` (see
 * `_app.tsx`).
 *
 * `?create-project` rides as a deep-link overlay opening the create dialog for
 * standalone links into this Dashboard destination.
 */
export interface ProjectsSearch {
  /** Open the create-project dialog. */
  'create-project'?: boolean
}

export const Route = createFileRoute('/_app/projects')({
  validateSearch: (search: Record<string, unknown>): ProjectsSearch => ({
    'create-project':
      search['create-project'] === true || search['create-project'] === 'true'
        ? true
        : undefined,
  }),
  component: ProjectsPage,
})
